import { Button } from "../../components/forms/Form";
import "./CreateStoreModal.css";
const formInput = (props) => {
  return (
    <input
      {...props.value}
      placeholder={props.placeholder}
      type="text"
      className="create-store-form-input form-item"
      onChange={(event) =>
        props.handleChangeInput(props.target, event.target.value)
      }
    ></input>
  );
};
export const CreateStoreForm = (props) => {
  // console.log("modal", props);
  return (
    <div className="create-store-form">
      {formInput({
        placeholder: "Nome ",
        target: "siteName",
        handleChangeInput: props.handleChangeInput,
      })}
      {/* {props.error && (
        <p style={{ color: "red", fontWeight: "600" }}>
          {props.error.response.data.message}
        </p>
      )} */}

      {formInput({
        placeholder: "URL",
        target: "siteHostname",
        handleChangeInput: props.handleChangeInput,
      })}

      {formInput({
        placeholder: "Azienda",
        target: "siteCompanyName",
        handleChangeInput: props.handleChangeInput,
      })}

      <div className="create-store-button-container">
        <Button
          text={"ANNULLA"}
          className={"exit-button"}
          handleSubmit={props.togglePopUp}
        />
        <Button
          text={"CREA"}
          loading={props.loading}
          handleSubmit={props.handleSubmit}
          disabled={props.disabled()}
        />
      </div>
    </div>
  );
};
